export enum EInitialValuesActionType {
    ADD = 'ADD',
    CHANGE = 'CHANGE',
    INIT = 'INIT',
    CLEAR = 'CLEAR',
}

export enum EKSSettingsFields {
    CrColumns = 'crColumns',
    SheetCode = 'sheetCode',
    ColumnName = 'columnName',
    SQL = 'sql'
}
